import { SvgIcon } from '@material-ui/core'
import React from 'react'

export default function RecordScreenIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 25" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 12.75C3 7.36522 7.36522 3 12.75 3C18.1348 3 22.5 7.36522 22.5 12.75C22.5 18.1348 18.1348 22.5 12.75 22.5C7.36522 22.5 3 18.1348 3 12.75ZM12.75 4.5C8.19365 4.5 4.5 8.19365 4.5 12.75C4.5 17.3063 8.19365 21 12.75 21C17.3063 21 21 17.3063 21 12.75C21 8.19365 17.3063 4.5 12.75 4.5Z"
            />
            <path d="M6.75 12.75C6.75 9.43629 9.43629 6.75 12.75 6.75C16.0637 6.75 18.75 9.43629 18.75 12.75C18.75 16.0637 16.0637 18.75 12.75 18.75C9.43629 18.75 6.75 16.0637 6.75 12.75Z" />
        </SvgIcon>
    )
}
